export default "__VITE_ASSET__CNthFa$x__"